module.exports = __webpack_public_path__ + "static/media/back2.ad974f91.jpg";